import React, { useState, useEffect,useImperativeHandle ,forwardRef} from "react";
import {
  Button,
  Row,
  Col,
  notification
} from "antd";
import { SearchOutlined, EditFilled,DeleteFilled,FrownOutlined } from "@ant-design/icons";
import "../css/product.css";
import "../css/scanstatus.css";
import axios from "axios";
import { path, src } from "../network/conn";
import noData from "../images/nodata.png";
const Scanstatus = forwardRef((Props,ref) =>{
  useImperativeHandle(ref, () => ({
    handlePropsReload(){
      console.log('childprops');
      handleScanData();
    }
    }));
const key = "updatable";
const user = sessionStorage.getItem('user');
const [patientList, setPatientList]   = useState([]);
const [dataSource, setdataSource]     = useState([]);
const [scanData , setScanData]        = useState([]);
const [Loading,setLoading]            = useState(true);
const handleScanData = () => {
    setLoading(true);
    let BaseURL = path + src + "scanentrylist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        console.log(response);
        let filteredData = response.data.filter((list)=>{return  list.process!='completed' && list.process!='Cancel' });
        console.log('filteredData',filteredData);
        let sortedData = filteredData.sort((a,b)=>{return a.code.split('-')[1]-b.code.split('-')[1]});
        setdataSource(sortedData);        
        setLoading(false);
        handlePatientData(response.data);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
      });
  };
  const openNotification = (e) => {
    notification.open({
      message: 'Sucesss',
      description:
        e,
      icon: <FrownOutlined style={{ color: 'green' }}/>,
    });
  };
  const handleComplete = (e)=>{
    let scanId = e.target.id;
    let BaseURL = path + src + "updateScanEntry.php?id=" + scanId;
    axios
      .get(BaseURL)
      .then((response) => {
        console.log(response);       
        handleScanData();
        openNotification(response.data);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
      });
  }
  const handlePatientData = (scanData) => {
    let BaseURL = path + src + "patientlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        console.log(response);
        setPatientList(response.data);
        handleScanDetails(scanData,response.data);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
      });
  };
  const handleScanDetails = (scanData,patientDetails) => {
    console.log(scanData,patientDetails);
    let patientData = Object.assign([],patientDetails);
    let scanList    = Object.assign([],scanData.filter((list)=>{return  list.process!='completed' && list.process!='Cancel'}));
    console.log(scanList,patientData);
    let scanDetail  = [];
    scanList.map((list)=>{
        console.log(list);
        let dataObj     = {};
        let patientList = patientData.find((listData)=>{return listData.code == list.patient}); 
        console.log(patientList);
        dataObj['scancode']     = list.code;
        dataObj['patientname']  = patientList.patientname;
        dataObj['patientcode']  = patientList.code;
        dataObj['patientClass'] = patientList.gender == 'Male' ? 'avatarMaleIcon2' : 'avatarFemaleIcon2';
        scanDetail.push(dataObj);
    });
    console.log('scanData',scanDetail);
    setScanData(scanDetail);
  }
  
useEffect(() => {
   handleScanData();
  }, []);
return <>
<Row gutter={24} className="overAllDiv">
    { scanData[0] ? scanData.map(list=>
        <Col span={6}>
        <div className="card">
            <div className="cardHolder">
            <div className={list.patientClass}></div>
            <div className="labelText">Count:{list.scancode}</div>
            <div className="labelText">Patientcode:{list.patientcode}</div>
            <div className="labelText">Patientname:{list.patientname}</div>
            <button id={list.scancode} className="successButto" onClick={handleComplete}>Done</button>
            </div>
        </div>
    </Col>
        ) : <div style={{maxHeight:'60%',width:'40%',margin:'auto'}}><img src={noData} height="80%" width="100%"></img></div>}
</Row>

</>
});
export default Scanstatus;